import React from 'react';
import { Route, Routes } from 'react-router-dom';

import routes from './components/routes';
import './assets/css/app.css';
import './assets/css/flickity.css';
import './assets/css/all.min.css';

const App = () => {

    console.log("API:", process.env.REACT_APP_API_URL);
console.log("IMAGE URL:", process.env.REACT_APP_IMAGE_URL);


    return (
        <>        
        <div className="root-content">
            <Routes>
                {routes.map(route => (
                    <Route key={route.path} path={route.path} element={<route.component />} />
                ))}
            </Routes>
        </div>
        
        </>
    )
}
export default App;
